import { baseApi } from '../../services/baseApi';
import { ApiEndPoints } from '../../constants/apiEndPoints';

/** Response from POST /upload/s3/ — the backend stores the file and returns its URL. */
export interface UploadResult {
  url: string;
  key: string;
  content_type: string;
  size: number;
}

export const uploadApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // Upload a single file. Body is multipart/form-data (field name: "file").
    // fetchBaseQuery sets the boundary/Content-Type automatically for FormData.
    uploadS3: build.mutation<UploadResult, File>({
      query: (file) => {
        const form = new FormData();
        form.append('file', file);
        return { url: `${ApiEndPoints.uploadS3}/`, method: 'POST', body: form };
      },
    }),
  }),
});

export const { useUploadS3Mutation } = uploadApi;
